import React from "react";
// import { useTranslation } from "react-i18next";

const ImagesSlider = ({ images, showButton = false }) => {
  // const { t } = useTranslation();
  return (
    <div className="w-full max-w-6xl mx-auto py-12">
      {/* Images Section */}
      <div className="relative overflow-hidden py-8 whitespace-nowrap">
        {/* Left Gradient Overlay */}
        <div className="absolute top-0 left-0 w-16 md:w-32 h-full z-10 bg-gradient-to-r from-[black] via-transparent to-transparent"></div>

        {/* Sliding Images */}
        <div className="inline-block animate-slide">
          {images.concat(images).map(({ src, alt }, index) => (
            <img
              key={index}
              src={src}
              alt={alt}
              className="w-[600px] h-96 mx-4 md:mx-3 inline-block cover object-cover rounded-lg shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl"
            />
          ))}
        </div>

        {/* Right Gradient Overlay */}
        <div className="absolute top-0 right-0 w-16 md:w-32 h-full z-10 bg-gradient-to-l from-[black] via-transparent to-transparent"></div>
      </div>
      {showButton && (
        <div className="mt-8 w-full text-center">
          <a
            href="/gallery"
            className="relative overflow-hidden py-4 px-8 rounded-md bg-white hover:bg-[#BD0E0E] text-black hover:text-white border-none cursor-pointer group font-semibold"
          >
            View All
          </a>
        </div>
      )}
    </div>
  );
};

export default ImagesSlider;
